import React from 'react';
import './contact.css';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import LocationOnIcon from '@material-ui/icons/LocationOn';


function Contact() {
  return (
    <div className='contactsec'>

        <div className="coursessec">
            <div className="introabout">
                <p className="abouttitle">Contact</p>
                <p className="subabout">Home <span><ArrowForwardIosIcon className='spanicon' /><ArrowForwardIosIcon className='spanicon1' /></span>contact</p>
            </div>
        </div>


          <div className="contactsecform">
              <section class="contact" />
              <div class="cont container">
                  <div class="contact-text">
                      <p>Drop your inquiry here and our experts will get back to you.</p>
                      <h6>Address</h6>
                      <p class="address">
                          35, 2nd floor, Vinay arcade,Nr. Kamal Choice, Opp. Maninagar Rly. Station,Ahmedabad, Gujarat
                      </p>
                      <h6>Email</h6>
                      <p class="mail">info@hnbinfo.com</p>
                  </div>
                  <div class="contact-form">
                      <form />
                      <label for="name" className='secname'>Name :</label>
                      <input type="text" name="name" id="name" required /><br />
                      <label for="email" className='secname1'>Email :</label>
                      <input type="email" name="email" id="email" required /><br />
                      <label for="message" className='secname'>Message :</label>
                      <textarea name="message" id="message" cols="30" rows="5" required></textarea><br />
                      <input type="submit" className='secbutton' value="submit" />
                      <form />
                  </div>
              </div>
              <section />
          </div>

        <h2 className="locations">
            Some of Our Loaction and branches
        </h2>
          <div className="locationsimgs">
              <p className="loactionimg">
                  <LocationOnIcon /><strong>H & B Computer Education, Maninagar</strong><br/>
                  <p className="subloca">301, 2nd Floor, Gopal Tower  Nr. Maninagar Railway Station, Maninagar, Ahmedabad, Gujarat 380008</p>
              </p>

              <p className="loactionimg">
                  <LocationOnIcon /><strong>H & B Computer Education, Gandhinagar</strong><br/>
                  <p className="subloca">3rd Floor, Kailash Sagar Complex, Sector 22, Landmark: Above SBI Bank, Gandhinagar. 382022</p>
              </p>
            </div>


              <div className="locationsimgs">
              <p className="loactionimg">
                  <LocationOnIcon /><strong>H & B Computer Education, V. V. Nagar</strong><br/>
                  <p className="subloca">3rd floor, Shiv complex,Opp honest rest,Mota bazar, Vv nagar, Anand.</p>
              </p>
              <p className="loactionimg">
                  <LocationOnIcon /><strong>H & B Computer Education, Chandkheda</strong><br/>
                  <p className="subloca">210/ Sukan Mall, Nr. Visat Petrol Pump,Chandkheda, Sabarmati, Ahmedabad</p>
              </p>
          </div>

        </div>
  )
}

export default Contact